var map = {
	"./sta0.png": 2221,
	"./sta1.png": 9545,
	"./sta2.png": 5859,
	"./sta3.png": 6811,
	"./sta4.png": 3393,
	"./sta5.png": 4974,
	"./statusbar.png": 3025
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2286;